import ready from '../../../../src-core/js/utils';

const selectors = {
  card: '.reveal-card',
  content: '.reveal-card_content',
}

function getDuration(card) {
  if (card) {
    const durationString = card.computedStyleMap().get('transition-duration').toString();

    if (durationString.endsWith('ms')) {
      return parseInt(durationString);
    } else if (durationString.endsWith('s')) {
      return parseInt(durationString) * 1000;
    }
  }

  return 0;
}

function waitFor(time) {
  return new Promise(resolve => setTimeout(resolve, time));
}


export async function showCard(el, durationOption) {
  const card = el?.closest(selectors.card);

  const duration = Number.isInteger(durationOption) ? durationOption : getDuration(card);

  if (card) {
    resizeCard(card);
    card.classList.add('reveal-card--shown');

    card.classList.add('reveal-card--showing');
    await waitFor(duration);
    card.classList.remove('reveal-card--showing');
  }
}
export async function hideCard(el, durationOption) {
  const card = el?.closest(selectors.card);
  const duration = Number.isInteger(durationOption) ? durationOption : getDuration(card);

  if (card) {
    resizeCard(card);
    card.classList.remove('reveal-card--shown');

    card.classList.add('reveal-card--hiding');
    await waitFor(duration);
    card.classList.remove('reveal-card--hiding');
  }
}

function resizeCard(card) {
  const content = card.querySelector(selectors.content);
  card.style.setProperty('--reveal-card-height', `${content.offsetHeight}px`);
}

export function initSliderCards() {
  document.querySelectorAll(selectors.card)
    .forEach(resizeCard)
}